import { useTheme } from '@mui/material';

// Minimal heading for the reimbursement form - no "signed in as" / sign
// out here, since the login gate (Planning Center) lives a level up, in
// congregantPortal/portalDonationsReimbursementsForm.js.
const PageHeader = ({ eyebrow, heading }) => {
    const theme = useTheme();

    const eyebrowStyle = {
        fontFamily: theme.typography.fontFamily,
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: theme.palette.brand.brass,
        margin: '0 0 6px',
    };

    const headingStyle = {
        fontFamily: theme.typography.secondaryFontFamily,
        fontWeight: 600,
        color: theme.palette.primary.dark,
        fontSize: 'min(8vw, 34px)',
        margin: 0,
    };

    return (
        <div style={{ marginBottom: '24px' }}>
            <div style={eyebrowStyle}>{eyebrow}</div>
            <h1 style={headingStyle}>{heading}</h1>
        </div>
    );
};

export default PageHeader;
